import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { moduleRedirect, type ExchangeModule } from "@/lib/exchangeModules";

/** Renders the page only when its Exchange module is switched on. */
export function ExchangeModuleRoute({ module, children }: { module: ExchangeModule; children: ReactNode }) {
  const to = moduleRedirect(module);
  if (to) return <Navigate to={to} replace />;
  return <>{children}</>;
}
